import React from "react";

const C_V_TABLE = React.memo(
  ({ row, field, child_array }) => {
    // Optional: You can calculate the row count here if you want the button
    // to display something like "Buka (3)" instead of just "Buka"
    const child_uuid = row?.child_uuid || "";
    const count = (child_array || []).filter(
      (item) => (item?.parent_uuid_temp || "") === child_uuid,
    ).length;

    return (
      <div
        className="cell_text_fast"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <div
          className="button_small background_black"
          style={{ pointerEvents: "none" }} // Let the parent td handle the click
        >
          Buka {count > 0 ? `(${count})` : ""}
        </div>
      </div>
    );
  },
  (prevProps, nextProps) =>
    prevProps.row?.child_uuid === nextProps.row?.child_uuid &&
    prevProps.child_array === nextProps.child_array,
);

export default C_V_TABLE;
